export default "__VITE_ASSET__Bhh_gKL6__"